import { TranslateService } from '@ngx-translate/core';

import {VehicleLocation} from './VehicleLocation';
import {VehicleControlIndicator} from './VehicleControlIndicator';
import {Driver} from './Driver';
import {VehicleTacho} from './VehicleTacho';
import { NetworkType } from '@src/app/enum/network.enum';
import { ParameterTypeEnum } from '@commons/enums/parameter-type.enum';

class VehicleTranslate {
  constructor(public translate?: TranslateService) {}
}

export class Vehicle extends VehicleTranslate {
  public blockerParametrId?: number; // Id parametru blokady z ControlIndicators
  public blockerParametrIdOut2? :number; // Id parametru blokady z ControlIndicators
  /**
   * ConnectionStatus
   */
  public CS: number = 0;
  public ControlIndicators?: VehicleControlIndicator[];
  /**
   * Id elektronicznie identyfikatora jaki się zalogował jako ostatni (bieżący traktowany jest jako ostatni) (LastDriverElectronicId)
   */
  public LD: string = '';
  public SN: string = '';
  /**
   * DriverID
   */
  public DR: number = 0;
  public LastDriver?: Driver;
  /**
   * Ostatnia zmiana pozycja pojazdu (bieżąca jest jako ostatnia) (LastKnownLocation)
   */
  public LL?: VehicleLocation;
  /**
   * ModuleStatus
   */
  public MS: number = 0;
  /**
   * Name
   */
  public Nm: string = '';
  /**
   * RegistrationNumber
   */
  public RN: string = '';
  /**
   * Status
   */
  public St: number = 0;
  /**
   * VehicleId
   */

  /* Czy pojazd jest zarejestrowany w sentgeo */
  public RS: boolean;
  /* Czy pojazd ma tacho */
  public TC: boolean;

  public Id: number = 0;
  public VehicleAngle = 0;
  public LastUpdated?: Date;
  public LastUpdatedFrom?: string;

  public Tacho?: VehicleTacho;
  public LastPositionLat?: number;
  public LastPositionLon?: number;

  public MF: number = 0;

  /**
   * BusinessNumber
   */
  public BN: string = '';
  /**
   * DevicePin
   */
  public DP: string = '';

  /**
   * Network type 2g/5g etc.
  */
  public DN: NetworkType = '' as any;

  /**
   * RegisterEToll
   */
  public RE: boolean = false;

  /**
   * SendToEToll
   */
  public SE: boolean = false;

  /**
   * ETollStatus
   */
  public ES: number = 0;
  public SentGeoId: string;

  // SentGeo
  public SG: number = 0;

  constructor(obj?: Vehicle, translate?: TranslateService) {
    super(translate);
    if (obj !== undefined) {
      Object.assign(this, obj);
    }
  }

  public get mainFuel(): VehicleControlIndicator | undefined {

    if (!this.ControlIndicators) {
      return undefined;
    }

    let fuel: VehicleControlIndicator | undefined = undefined;

    if (this.MF !== undefined && this.MF > 0) {
      fuel = this.ControlIndicators.find(p => p && p.Id === this.MF);
    }

    return fuel;
  }

  public getEtollStatusHint(): string {
    switch (this.ES) {
      case 0:
        return this.translate?.instant('unregistered');
      case 1:
        return this.translate?.instant('disabled');
      case 2:
        return this.translate?.instant('enabled');
      case 3:
        return this.translate?.instant('vehicle-list-item.etoll-not-sending');
      case 4:
        return this.translate?.instant('delayedSending');
      default:
        return '';
    }
  }
}

export class GetVehicleParamNameByIds {

  private paramID: number;
  private vehicle: Vehicle;

  constructor(paramID: number, vehicle: Vehicle) {
    this.paramID = paramID;
    this.vehicle = vehicle;
  }

  public get paramName(): string {
    const param = this.vehicle.ControlIndicators?.find(item => item.Id === this.paramID);
    return param?.Nm || 'Undefined param';
  }

}

export class GetVehicleParamByTypeParameter {

  private parameterType: ParameterTypeEnum;
  private vehicle: Vehicle;

  constructor(
    parameterType: Exclude<ParameterTypeEnum, [ParameterTypeEnum.Binary, ParameterTypeEnum.Analog]>,
    vehicle: Vehicle,
  ) {
    this.parameterType = parameterType;
    this.vehicle = vehicle;
  }

  public get paramData(): VehicleControlIndicator {
    const param = this.vehicle.ControlIndicators?.find(item => item.Tp === this.parameterType);
    return param!;
  }

}
